import { createApp } from 'vue';
import App from './App.vue';
import Maska from 'maska';

const app = createApp(App, {
	tarifes: JSON.parse(document.querySelector('#tarifesData').innerText)
});
app.use(Maska);
app.mount('#app');
